import { fetchVisitorIP } from "./ipServices.js";

export async function prepareForm() {
  const ipinfo = await fetchVisitorIP();

  if (ipinfo) {
    // form elements - look for both applicant and enrollment prefixed fields
    const applicant_ip = document.getElementById("applicant_ip");
    const enrollment_ip = document.getElementById("enrollment_ip");
    const ipField = applicant_ip || enrollment_ip;

    const applicant_state = document.getElementById("applicant_state");
    const enrollment_state = document.getElementById("enrollment_state");
    const stateField = applicant_state || enrollment_state;

    const applicant_country = document.getElementById("applicant_country");
    const enrollment_country = document.getElementById("enrollment_country");
    const countryField = applicant_country || enrollment_country;

    if (ipField && ipinfo.ip) ipField.value = ipinfo.ip;
    if (stateField && ipinfo.region) stateField.value = ipinfo.region;
    if (countryField && ipinfo.country) countryField.value = ipinfo.country;
  }
}
